import { h } from 'preact';
import ClockIcon from 'utils/icon/clock.svg';

export const showInventoryMessageFn = (currentVariant) => {
  if (
    !currentVariant ||
    !currentVariant.quantityAvailable ||
    currentVariant.quantityAvailable > 10 ||
    currentVariant.quantityAvailable < 1
  ) {
    return false;
  }
  return true;
}

export const InventoryMessage = ({ inventoryMessageData }) => (
  <div {...(inventoryMessageData?.ab_testing_id ? { id: inventoryMessageData.ab_testing_id } : {})} className="flex gap-2 items-center">
    <ClockIcon />
    <p style={`color: ${inventoryMessageData?.msg_color}`} className="text-body-2 leading-none mb-[2px]">
      {inventoryMessageData?.inventory_msg}
    </p>
  </div>
);